import documentsRoutingKeys from "Areas/Documents/routingKeys";
import settingsRoutingKeys from "Areas/Settings/routingKeys";
import summaryReportsRoutingKeys from "Areas/SummaryReports/routingKeys";
import { APP_SIZES } from "Common/componentUtils/constants";
import forEach from "lodash/forEach";
import React, { useEffect, useMemo, useRef } from "react";
import DocumentsSidebarMenu from "../Documents";
import DocumentsSidebarFloat from "../DocumentsFloat";
import SettingsSidebarMenu from "../Settings";
import SummaryReportSidebarMenu from "../SummaryReports";
import WorkSpacesSidebarMenu from "../WorkSpaces";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
const sidebarMenuMap = {
    floatSideBar: DocumentsSidebarFloat
};
const documentMenuKeys = [];
export const documentWithFloatSidebar = [DOCUMENT_TYPE.GRAPH, DOCUMENT_TYPE.MAP];
forEach(documentsRoutingKeys, routingKey => {
    sidebarMenuMap[routingKey] = DocumentsSidebarMenu;
    documentMenuKeys.push(routingKey);
});
forEach(settingsRoutingKeys, routingKey => {
    sidebarMenuMap[routingKey] = SettingsSidebarMenu;
});
forEach(summaryReportsRoutingKeys, routingKey => {
    sidebarMenuMap[routingKey] = SummaryReportSidebarMenu;
});
export default function Switcher({ routingPageKey, onSidebarComponentChanged, backUrlHash, locationHash, documentType, ...other }) {
    const Component = useMemo(() => {
        if (routingPageKey && documentMenuKeys.includes(routingPageKey)) {
            if (documentType && documentWithFloatSidebar.includes(documentType)) {
                return sidebarMenuMap.floatSideBar;
            }
        }
        return (routingPageKey && sidebarMenuMap[routingPageKey]) || WorkSpacesSidebarMenu;
    }, [routingPageKey, documentType]);
    const pageHashPrev = useRef(locationHash);
    useEffect(() => {
        pageHashPrev.current = locationHash;
    }, [locationHash]);
    useEffect(() => () => {
        onSidebarComponentChanged && onSidebarComponentChanged(pageHashPrev.current);
    }, [Component]);
    return React.createElement(Component, { backUrlHash: backUrlHash, ...other });
}
Switcher.getWidth = (_, isExpanded) => !isExpanded
    ? APP_SIZES.SIDEBAR_COLLAPSED_WIDTH
    : APP_SIZES.SIDEBAR_COLLAPSED_WIDTH + APP_SIZES.SIDEBAR_MAIN_WIDTH;
